// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__CQ1qg","info":"UpdateTermsInfo_info__22WvZ"};